import { createAsyncThunk } from '@reduxjs/toolkit'
import { getVideoListPath } from 'helpers/brandHelpers'
import { userAccountInfo } from 'helpers/user'
import assetsAPI from 'services/assets'

export const getVideos = createAsyncThunk(
  'videos/getVideos',
  async (payload, { rejectWithValue }) => {
    try {
      const { accountType } = userAccountInfo

      const videoPath = getVideoListPath(accountType)
      const response = await assetsAPI.getVideoList(videoPath)
      return { response, videoListAccountType: accountType }

      return null
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
